var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnersBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 324,
    viewBox: "0 0 360 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1379_7415)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 324,
    fill: "#120F17"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_f_1379_7415)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cy: 33.5,
    rx: 126,
    ry: 95.5,
    fill: "#524B87"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.3945,
    y: 278.873,
    width: 85.0605,
    height: 49.9064,
    fill: "url(#paint0_linear_1379_7415)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 329.115L49.39 278.874L49.39 329.115L0 329.115Z",
    fill: "url(#paint1_linear_1379_7415)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.238,
    y: 130.354,
    width: 79.2991,
    height: 161.159,
    fill: "url(#paint2_linear_1379_7415)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28 291.514H359.087V328.982H237.055L279.28 291.514Z",
    fill: "url(#paint3_linear_1379_7415)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.413 278.743L280.557 130.442L280.557 292.053L236.942 329.07L133.413 329.07L133.413 278.743Z",
    fill: "url(#paint4_linear_1379_7415)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 132.5,
    x2: 280,
    y2: 132.5,
    stroke: "#4D4563",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 2.18557e-8,
    x2: 49.5,
    y2: 280,
    stroke: "#4D4563",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.5,
    y1: 2.18557e-8,
    x2: 216.5,
    y2: 196,
    stroke: "#4D4563",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.5,
    y1: 2.18557e-8,
    x2: 280.5,
    y2: 133,
    stroke: "#4D4563",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 195.5,
    x2: 216,
    y2: 195.5,
    stroke: "#4D4563",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1379_7415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 132.5,
    r: 1.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1379_7415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 195.5,
    r: 1.5,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1379_7415",
    x: -376,
    y: -312,
    width: 752,
    height: 691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_1379_7415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1379_7415",
    x: 197,
    y: 113,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1379_7415"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1379_7415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1379_7415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1379_7415",
    x: 197,
    y: 176,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1379_7415"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1379_7415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1379_7415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_7415",
    x1: 91.9248,
    y1: 278.873,
    x2: 91.9248,
    y2: 328.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A10193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998781,
    stopColor: "#7B06C5",
    stopOpacity: 0.645833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6405C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1379_7415",
    x1: -9.69064e-7,
    y1: 303.995,
    x2: 49.39,
    y2: 303.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6405C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#7B06C5",
    stopOpacity: 0.9075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD09C8",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1379_7415",
    x1: 319.888,
    y1: 130.354,
    x2: 319.888,
    y2: 291.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6706C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#9D02AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A10193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1379_7415",
    x1: 359.087,
    y1: 328.982,
    x2: 253.135,
    y2: 328.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6806C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#6C06C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960089"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1379_7415",
    x1: 135.288,
    y1: 320.179,
    x2: 279.842,
    y2: 206.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#670F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#6F0E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652646,
    stopColor: "#8A09A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A20193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_7415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 324,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersBg);
export default __webpack_public_path__ + "static/media/partners-bg.45b4598ccbcec4f7bc24594a8f650464.svg";
export { ForwardRef as ReactComponent };